<template>
    <div>
        <BrethrenHero title="Who we are"/>

        <div class="p-8 md:p-20 text-lg">
            <div class="font-bold uppercase text-2xl">the saints gathering church</div>

            <p>
                The Saints Gathering Church is a body of believers who are passionate about Jesus’s dream to see all men saved and discipled. From our first service on November 8, 2015, the vision has stayed the same. We want to raise proof of the victorious life in Christ. The work has grown and expanded into several thriving branches.
            </p>

            <div class="mt-10">
                <img src="../assets/images/who_we_are.png" class="w-full rounded" alt="Pastor teaching in church">
            </div>

            <div class="grid lg:grid-cols-2">
                <div class="md:p-10 mt-5">
                    <div class="font-bold uppercase text-2xl">OUR VISION</div>
                    <div>We share in God’s dream for the world. We believe that the whole world will be filled with the glory of God as the waters cover the sea. We see Jesus preached, believed, and taught in every nation, every city, every street, and everywhere in the world.

                    We are running with God’s word to us: “From here to the uttermost.”
                    </div>
                </div>
                <div class="md:p-10 mt-5">
                    <div class="font-bold uppercase text-2xl">OUR Mission</div>
                    <div>Jesus in Matthew 28:18-20 instructs us to go into all the world and make disciples of every nation. This is our mission. To share the gospel everywhere, demonstrate the power of God, and raise believers who can do the same.</div>
                    <div>
                        <ul>
                            <li class="ms-10">To raise soulwinners: men and women with the fire of God and passion for souls.</li>
                            <li class="ms-10">To raise believers who understand, teach, and can defend God’s word.</li>
                            <li class="ms-10">To raise believers who are under the lordship of Jesus and the word.</li>
                            <li class="ms-10">To raise believers who can demonstrate the power of God and destroy the works of satan.</li>
                            <li class="ms-10">To see people’s lives radically transformed by God’s word.</li>
                            <li class="ms-10">To raise men and women who live above life’s circumstances and are proofs of the victorious life in Christ.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-[#EEF1F4]">
            <div class="md:p-10 md:px-32 p-8">
                <div class="font-bold uppercase text-2xl">church confession</div>
                <div class="text-lg grid gap-5">
                    <div>
                        I am believer <br>
                        I believe that the Holy Spirit lives in me <br>
                        He is my seal <br>
                        He is my nature <br>
                        He convinces and reminds me of my righteousness <br>
                        I am the righteousness of God in Christ Jesus <br>
                        All my sins have been blotted out <br>
                        All my sins have been wiped <br>
                        I cannot be condemned <br>
                        I have passed from death to life <br>
                        There is no condemnation to me, for I am in Christ <br>
                        I am the forgiven. I am the holy. I am the accepted. I am the blameless <br>
                        I am the focus of the love of God <br>
                    </div>
                    
                    <div>
                        I have been immersed into the name of Jesus <br>
                        I have His authority. So, I cast out devils <br>
                        My zeal is my making. I direct my passion, I direct my zeal  <br>
                        I lay my hands on the sick and they are healed <br>
                        I lay my hands on people and they are filled with the Spirit <br>
                        I lay my hands on people and they begin to function in the things of the Spirit <br>
                        My hands are blessed <br>
                        My hands are supernatural tools for ministry <br>
                        When I lay my hands on people, the supernatural happens <br>
                        And when hands are laid on me, I receive the enablements of the Spirit <br>
                    </div>

                    <div>
                        There are no impossibilities to the power of God in me <br>
                        I walk in love  <br>
                        I live a life of honour <br>
                        I don't treat the gifts of God with dishonour or familiarity <br>
                        I watch my words. I say the right things <br>
                    </div>

                    <div>
                        I am the manifestation of the glory of Christ <br>
                        I am not my own. I am the work of Christ.  <br>
                        I am the glory of Christ <br>
                        I am born of the Spirit <br>
                        I come from outside human experience <br>
                        I come from outside of the flesh <br>
                        I am born of God. I am clean <br>
                    </div>

                    <div>
                        The Spirit of God is my nature <br>
                        I belong to God <br>
                        I don't have two fathers <br>
                        I only have one <br>
                        I am born of God <br>
                        I am a child of God <br>
                        I am what He says I am <br>
                        I have what He says I have <br>
                        I can do what He says I can do <br>
                    </div>

                    <div>
                        Glory to God!
                    </div>

                </div>
            </div>
        </div>

        <BecomeOurFamily />

        <BottomLinks />
    </div>
</template>

<script setup>
import BrethrenHero from '../components/BrethrenHero.vue';
import BecomeOurFamily from '../components/BecomeOurFamily.vue';
import BottomLinks from '../components/Who_we_are/BottomLinks.vue';
</script>

<style scoped>

</style>